import { nvl, nvlDateTypeReturnToStringOnlyDate } from 'utils/nvl';
import { getYMDFormatDate } from 'utils/getCustomFormatDate';
import { moduleScnMap } from 'utils/code';

export function makeDataLevel(d, pageIndex, pageSize, index) {
  return {
    index: pageIndex * pageSize + index + 1,
    moduleIdx: d.moduleIdx,
    modelNo: d.modelNo ? d.modelNo : '',
    modelNm: d.modelNm ? d.modelNm : '',
    deadline: nvl(d.calibration, null) === null ? '' : nvlDateTypeReturnToStringOnlyDate(d.calibration.deadline, ''),
    calibration: d.calibration,
    moduleGroup: d.moduleGroup,
    moduleTypeNm: d.moduleType === 'DT' ? '이동형' : '휴대형',
    moduleType: d.moduleType ? d.moduleType : '0',
    moduleScnNm: moduleScnMap[d.moduleScn + ''].viewTitle,
    moduleScn: d.moduleScn ? d.moduleScn : '-1',
    moduleStatus: d.moduleStatus,
    auth: nvl(d.auth, null) === null ? '' : d.auth.authNm,
    authIdx: nvl(d.auth, null) === null ? '' : d.auth.authIdx,
    areaNo: nvl(d.areaNo, null) === null ? '' : d.areaNo,
    areaNm: nvl(d.areaNm, null) === null ? '' : d.areaNm,
    xAxis: d.xaxis,
    yAxis: d.yaxis,
    rgstId: d.rgstId,
    rgstDt: getYMDFormatDate(new Date(d.rgstDt)),
  };
}
